<template>
    <div class="student-list-container">
        <div class="card-container">
            <div class="search-box">
                <el-input v-model="searchForm.keyword" placeholder="考生号/姓名" clearable style="width: 200px;"></el-input>
                <el-select v-model="searchForm.major" placeholder="专业" clearable style="width: 200px;">
                    <el-option label="全部" value=""></el-option>
                </el-select>
                <el-select v-model="searchForm.province" placeholder="省份" clearable style="width: 200px;">
                    <el-option label="全部" value=""></el-option>
                </el-select>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
            </div>

            <div class="data-table-wrapper">
                    <div class="data-table-body">
                        <el-table :data="tableData" border :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}">
                            <el-table-column type="index" label="序号" min-width="60" align="center"></el-table-column>
                            <el-table-column prop="ksh" label="考生号" min-width="180" align="center"></el-table-column>
                            <el-table-column prop="xm" label="姓名" min-width="100" align="center"></el-table-column>
                            <el-table-column prop="xbmc" label="性别" min-width="60" align="center"></el-table-column>
                            <el-table-column prop="mzmc" label="民族" min-width="80" align="center"></el-table-column>
                            <el-table-column prop="sheng" label="省份" min-width="100" align="center"></el-table-column>
                            <el-table-column prop="lqzymc" label="录取专业" min-width="200"></el-table-column>
                            <el-table-column prop="cj" label="成绩" min-width="80" align="center"></el-table-column>
                            <el-table-column label="操作" min-width="180" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                                    <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>

            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pagination.page"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination.total"
                style="margin-top: 20px;">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StudentList',
    data() {
        return {
            searchForm: {
                keyword: '',
                major: '',
                province: ''
            },
            tableData: [],
            loading: false,
            pagination: {
                page: 1,
                pageSize: 20,
                total: 0
            }
        };
    },
    methods: {
        loadData() {
            this.loading = true;
            // TODO: 加载数据
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        },
        handleSearch() {
            this.pagination.page = 1;
            this.loadData();
        },
        handleReset() {
            this.searchForm = {
                keyword: '',
                major: '',
                province: ''
            };
            this.handleSearch();
        },
        handleView() {
            // TODO: 当实现查看功能时，需要接收row参数来获取行信息
            this.$message.info('查看功能开发中...');
        },
        handleEdit() {
            // TODO: 当实现编辑功能时，需要接收row参数来获取行信息
            this.$message.info('编辑功能开发中...');
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.loadData();
        }
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style scoped>
.search-box {
    margin-bottom: 20px;
}

.data-table-wrapper {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: auto;
    max-height: calc(100vh - 520px);
}

.data-table-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.data-table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.data-table-body {
    width: max-content;
    min-width: 100%;
}

.data-table-body >>> .el-table {
    font-size: 13px;
}

.data-table-body >>> .el-table th,
.data-table-body >>> .el-table td {
    padding: 8px 0 !important;
}

.data-table-body >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table-body >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.data-table-body >>> .el-table .cell {
    padding: 0 8px;
}
</style>

